export const getQueryGroupId = () => {
  // get group id from url param
  let search = window.location.search;
  const params = new URLSearchParams(search);
  let groupId = params.get("group_id");
  return groupId ? parseInt(groupId) : 0;
};

export const getQueryNewGroup = () => {
  // get group id from url param
  let search = window.location.search;
  const params = new URLSearchParams(search);
  let newGroup = params.get("newGroup");
  return newGroup ? newGroup : false;
};
